import { LocalStore, useLocalStore } from 'shared/helpers/Store';
import { DateTime } from 'luxon';

const INSTANT_TRANSFER_BANNER_ACCESS_TIME =
  'instant_transfer_access_banner_time';

export function useInstantTransferBannerAccessTime() {
  const time = useLocalStore(INSTANT_TRANSFER_BANNER_ACCESS_TIME);

  const setNextDay = () => {
    const currentDay = DateTime.now().plus({ days: 1 });
    LocalStore.set(
      INSTANT_TRANSFER_BANNER_ACCESS_TIME,
      currentDay.toMillis().toString(),
    );
  };

  const getAccess = () => {
    if (!time) {
      return true;
    }
    return DateTime.now().toMillis() > Number(time);
  };

  return { setNextDay, getAccess };
}
